import { format } from 'date-fns'

import { useDateStore } from '@/components/DateInput'
import { useGarageStore } from '@/modules/FindGarage'
import { VehicleAllocationList } from './VehicleAllocationList'
import styles from './VehicleAllocation.module.scss'
import { useMemo } from 'react'
import { useAuthStore } from '@/store/auth-store'
import { Role } from '@/types/auth'
import { useWorkstationStore } from '@/modules/Workstation/store'
import { useReaderLogStore } from '@/modules/FindControllerLog/store'

export const VehicleAllocation = () => {
    const { garage } = useGarageStore()
    const { workstation } = useWorkstationStore()
    const { source } = useReaderLogStore()
    const { date } = useDateStore()
    const { role } = useAuthStore()

    const allocationTitle = useMemo(() => {
        if (role === Role.MileageClerk) {
            return garage?.name
        }

        if (role === Role.PerformanceManager || role === Role.Controller) {
            return workstation?.workstationNumber
        }

        if (role === Role.Reader) {
            return source?.title
        }

        return ''
    }, [role, garage, workstation, source])

    return (
        <section className={styles.root}>
            <header className={styles.header}>
                <div className={styles.details}>
                    <h1 className={styles.title}>{allocationTitle} vehicle allocation</h1>
                    <p className={styles.date}>{format(date, 'cccc d MMMM')}</p>
                </div>
            </header>
            <div className={styles.container}>
                <VehicleAllocationList />
            </div>
        </section>
    )
}
